module.exports = __webpack_public_path__ + "static/media/combined-shape.08ffd4bc.svg";